import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business エンジニア評価レイアウト。権限チェックは子ルート側で行う（一覧は VIEW_ENGINEER_EVALUATION、詳細は本人なら権限不要）
 * @graph-connects none
 */
export const Route = createFileRoute('/engineer-evaluations')({
  component: EngineerEvaluationsLayout,
});

/** @graph-connects none */
function EngineerEvaluationsLayout() {
  return <Outlet />;
}
